import z from 'zod/v4';

export const APIStatus = {
  IDLE: 'idle',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  FAILED: 'failed',
  ERROR: 'error',
} as const;

export type APIStatus = (typeof APIStatus)[keyof typeof APIStatus];

export const Role = {
  SUPER_ADMIN: 'super_admin',
  EXTERNAL_ADMIN: 'external_admin',
  ALERT_DISPATCHER: 'alert_dispatcher',
  ALERT_MANAGER: 'alert_manager',
  DASHBOARD_ONLY: 'dashboard',
  DIRECTOR: 'director',
  MANAGER: 'manager',
  SERVICE_PROVIDER_MANAGER: 'service_provider_manager',
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const RoleLabel = {
  [Role.SUPER_ADMIN]: 'Super admin',
  [Role.EXTERNAL_ADMIN]: 'External admin',
  [Role.DIRECTOR]: 'Director',
  [Role.MANAGER]: 'Manager',
  [Role.ALERT_MANAGER]: 'FirstAlerts manager',
  [Role.ALERT_DISPATCHER]: 'FirstAlerts dispatcher',
  [Role.DASHBOARD_ONLY]: 'Dashboard only',
  [Role.SERVICE_PROVIDER_MANAGER]: 'Service provider manager',
} as const;

export const Org = {
  Saskatchewan: 'sk',
  BuddysQuest: 'bq',
  OneidaTS: 'onwts',
  OneidaBQ: 'onwbq',
  NisgaaValley: 'nvha',
  Enoch: 'ecn',

  // test orgs
  Ontario: 'sk2',
  Wisconsin: 'test',
  Check: 'check',
  BuddysQuest2: 'bq2',
  BuddysQuest3: 'bq3',
} as const;

export type Org = (typeof Org)[keyof typeof Org];

export const OrgSchema = z.union(
  (Object.values(Org) as Org[]).map((v) => z.literal(v)) as [z.ZodLiteral<Org>, ...z.ZodLiteral<Org>[]],
);

export const AppCode = {
  TalkingStick: 'ts',
  BuddysQuest: 'bq',

  // test app_code
  Test: 'test',
};

export type AppCode = (typeof AppCode)[keyof typeof AppCode];

export const ManagerPage = {
  LEPSManager: 'RegionalManager',
  FirstAlertsManager: 'FirstAlertsManager',
  ServiceProviderManager: 'ServiceProviderManager',
  Admin: 'Admin',
} as const;

export type ManagerPage = (typeof ManagerPage)[keyof typeof ManagerPage];

export const AdvocatePageType = {
  PeerAdvocate: 'PeerAdvocate',
  ServiceProvider: 'ServiceProvider',
} as const;

export type AdvocatePageType = (typeof AdvocatePageType)[keyof typeof AdvocatePageType];
